<template>
<v-layout row>
    <v-flex xs12>
      <v-card>
        <v-card-title primary-title class="grey lighten-4">
            <v-tooltip top>
                 <v-btn
                    slot="activator"
                    dark
                    @click.stop="helpdialog = true"
                    icon class="mx-0">
                <v-icon color="red">help</v-icon>
                </v-btn>
                <span>Inventario Papel de Seguridad</span>
            </v-tooltip>
            <h3 class="headline mb-0">Inventario Papel de Seguridad</h3>
            <v-spacer></v-spacer>
                <v-text-field
                    @change="onChange"
                    slot="input"
                    v-model="search"
                    append-icon="search"
                    label="Buscar"
                    single-line
                    hide-details
                ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="addPapel">Nuevo Lote</v-btn>
        </v-card-title>
        <div>
          <v-data-table
            :headers="headers"
            :items="papers"
            :pagination.sync="pagination"
            :total-items="total"
            :rows-per-page-items="rowsPerPageItems"
            :loading="loading"
            row
            wrap
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.lote }}</td>
              <td>DC-{{ props.item.start_in  }} - DC-{{ props.item.end_in }}</td>
              <td>DC-{{ props.item.papel }}</td>
              <td>{{ props.item.security_paper_unionize == null  ? 'No' : props.item.security_paper_unionize.unionize.cpc  }}</td>
              <td>{{ props.item.security_paper_unionize == null  ? 'No' :  props.item.security_paper_unionize.usado ? 'Sí' : 'No' }}</td>
              <td>{{ props.item.anulado ? 'Sí' : 'No' }}</td>
              <td>{{ props.item.created_at }}</td>
              <td class="justify-center layout px-0">
                <v-tooltip left>
                    <v-btn slot="activator" icon class="mx-0"  @click="editItem(props.item)">
                        <v-icon color="blue" class="mr-2">
                            edit
                        </v-icon>
                    </v-btn>
                    <span>Eitar Papel</span>
                </v-tooltip>
                <v-tooltip top>
                    <v-btn slot="activator" icon class="mx-0" @click="deleteItem(props.item)">
                        <v-icon color="red">
                            delete
                        </v-icon>
                    </v-btn>
                    <span>Eliminar Papel</span>
                </v-tooltip>
                <!-- <v-tooltip right>
                    <v-btn slot="activator" icon class="mx-0" @click="verItem(props.item)">
                      <v-icon dark color="green">description</v-icon>
                    </v-btn>
                    <span>Ver Papel</span>
                </v-tooltip> -->
              </td>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-flex>


    <!-- Inicio de dialogo -->
    <v-dialog v-model="helpdialog" max-width="600">
      <v-card>
        <v-card-title class="headline">Registrar LOTE de Papel de Seguridad</v-card-title>
          <v-card-text>
            <p>Registro del LOTE de papel de seguridad partiendo del Número de Papel Inicial hasta el Número de Papel Final por cada fajo de papeles en órden secuencial. </p>
            <p>La ruptura en la secuencia del número de papel hará referencia a un registro distinto y deberá ser registrada aparte.</p>
          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="helpdialog = false">
            Salir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->

    <!-- dialog para form create update security papers -->
    <v-dialog v-model="dialog" width="600" persistent>
      <FormPapers :tipo="tipo" :datos="getPapers" v-on:closeDialogRole="closeDialogRole($event)" />
    </v-dialog>
    <!-- fin dialog form create update security papers -->

    <!-- dialog para form papers -->
    <v-dialog v-model="dialogPapers" width="800" persistent>
      <FormPapersDetails :datos="getPapers" v-on:closeDialogPaper="closeDialogPaper($event)" v-on:closeDialogPaperDetail="closeDialogPaperDetail($event)" v-on:closeDialogPaperDelete="closeDialogPaperDelete($event)" />
    </v-dialog>
    <!-- fin dialog form papers -->

    </v-layout>
</template>

<script>
import axios from 'axios'
import FormPapers from '~/pages/cobranza/FormPapers.vue'
import FormPapersDetails from '~/pages/cobranza/FormPapersDetails.vue'

  export default {
    name: "admin-roles-view",

    components: {
      FormPapers,
      FormPapersDetails
    },

    data: () => ({
      dialog: false,
      dialogPapers: false,
      nota: {nombre: '', descripcion: ''},
      helpdialog: false,
      loading: false,
      total: 0,
      ultimopapel: "0",
      tipo: '',
      search: '',
      pagination: {},
      dialogPermissionRole: false,
      headers: [
       { text: 'LOTE', align: 'left', sortable: false, value: 'lote' },
        { text: 'INICIO - FIN', align: 'left', sortable: false, value: (['start_in', 'end_in']) },
        { text: 'NUM PAPEL', align: 'left', sortable: true, value: 'papel' },
        { text: 'CPC', align: 'left', sortable: false, value: 'cpc' },
        { text: 'USADO', align: 'left', sortable: false, value: 'usado' },
        { text: 'ANULADO', align: 'left', sortable: false, value: 'anulado' },
        { text: 'REGISTRADO', align: 'left', sortable: false, value: 'created_at' },
        { text: 'ACCIONES', align: 'center', value: '', sortable: false }
      ],
      rowsPerPageItems: [10, 20, 50, 100],
      papers: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        description: ''
      },
      defaultItem: {
        name: '',
        description: ''
      }
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Registrar nuevo Rol' : 'Editar Rol'
      },
      getPapers () {
          return this.editedItem
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      pagination() {
        this.getPaperByPagination();
      }
    },

    methods: {

      editItem (item) {
        this.tipo = "editar"
        this.editedIndex = this.papers.indexOf(item)
        item.papers = []
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      addPapel () {
        this.tipo = "crear"
        this.dialog = true
      },

      verItem(item) {
        this.editedIndex = this.papers.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogPapers = true
      },

      deleteItem (item) {
        const index = this.papers.indexOf(item)
        let confirmDelete =  confirm(`se eliminará el LOTE:  ${item.lote}, está seguro?`)
        if(confirmDelete){
          axios.delete(`/api/administration/cobranza/delete-papel/${item.id}`)
            .then(()=>{
              this.papers.splice(index, 1);
            })
            .catch(e => {
              console.log(e.response);
               this.loading = false
                if (e.response.data.errors) {
                  // this.form.errors.errors = e.response.data.errors
                  if (e.response.data.errors.papel_comprado) {
                    this.$store.dispatch('responseMessage', {
                      type: 'error',
                      text: e.response.data.errors.papel_comprado
                    })
                  }
                }else {
                  this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: e.response.data.error
                  })
                }
            });
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) { // update
          let formData = new FormData();
          for (var key in this.editedItem) {
            formData.append(key, this.editedItem[key]);
          }
          //console.log(this.editedItem,'aa')
          formData.set('_method', 'patch')
          axios.post(`/api/roles/admin/update_role`, formData)
          .then((resp) => {
            this.search = resp.data.name
            this.getPaperByPagination();
          })
          .catch(error => {
              console.log(error.response);
          });

        } else { // create
          this.submitFormRoles()
        }
        this.close()
      },

      async submitFormRoles () {
        axios.post(`/api/roles/admin/create_role`, this.editedItem)
          .then((resp) => {
            this.search = resp.data.name
            this.getPaperByPagination();
            //this.roles.push(resp.data)
          })
          .catch(error => {
              console.log(error.response);
          });
      },

      async getPaperByPagination() {
            this.loading = true;
            if (this.search) {
                await axios.get(`/api/administration/cobranza/inventario-papel-filter?query=${this.search}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        this.papers = res.data.data;
                        this.total = res.data.total;
                    })
                    .catch(e => {
                      console.log(e)
                    })
                    .finally(() => this.loading = false);
            }
            if (this.pagination.sortBy && !this.search) {
                const direction = this.pagination.descending ? 'desc' : 'asc';
                await axios.get(`/api/administration/cobranza/inventario-papel-order?direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        this.papers = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
            if(!this.search && !this.pagination.sortBy) {
                await axios.get(`/api/administration/cobranza/inventario-papel?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                      console.log(res.data)
                        this.papers = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
        },

        closeDialogPermissionRole () {
          this.dialogPermissionRole = false
          setTimeout(function(){
            this.id = null
          }, 3000)
        },

        onChange () {
            this.getPaperByPagination();
        },

        closeDialogRole (response) {
          if (response != null) {
            // var item = this.papers.find(papers => papers.id === response.id)
            // if (this.tipo == 'crear') {
            //   this.papers.push(response)
            // }else {
            //   Object.assign(item, response)
            // }
            // this.search = response.lote
            this.getPaperByPagination();
          }
          this.dialog = false
          setTimeout(function(){
            this.editItem = {}
            this.tipo = ''
          }, 3000)
        },

        closeDialogPaper (response) {
          this.getPaperByPagination();
          this.dialogPapers = false
          setTimeout(function(){
            this.editItem = {}
            this.tipo = ''
          }, 3000)
        },

        closeDialogPaperDetail (response) {
          if (response != null) {
            this.editedIndex = this.papers.indexOf(response)
            this.editedItem = Object.assign({}, response)
          }
        },

        closeDialogPaperDelete (response) {
          this.editedItem.papers.splice(response, 1);
        }

    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/cobranza/inventarioPapel.vue